import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountProfileRoutingModule } from './account-profile.routing';
import { SharedModule } from '../../../../../shared/shared.module';
import { AccountProfileTabsComponent } from './account-profile-tabs.component';
import { MfaRegistrationModalComponent } from './mfa-registration-modal/mfa-registration-modal.component';
import { AccountSettingsModule } from '../settings/account-settings.module';
import { AccountProfileComponent } from './account-profile.component';
import { ManualAuditIssuesModule } from '../../../manual-evaluations/manual-evaluation/manual-audit-issues/manual-audit-issues.module';

@NgModule({
  imports: [CommonModule, SharedModule, AccountProfileRoutingModule, AccountSettingsModule, ManualAuditIssuesModule],
  declarations: [AccountProfileTabsComponent, AccountProfileComponent, MfaRegistrationModalComponent],
  exports: [AccountProfileComponent],
})
export class AccountProfileModule {}
